import axios from 'axios';
import Button from 'react-bootstrap/Button';
import { fetchToken } from './Auth';

export const CsvFileDownloadBtn = ({ unitId }) => {
  const downloadCSVFile = () => {
    const headers = {
      accept: 'application/json',
      Authorization: 'Bearer ' + fetchToken(),
    };

    let filename;

    axios
      .get('/api/v1/units/' + unitId + '/items/?csv=true', {
        headers: headers,
        responseType: 'blob',
      })
      .then((response) => {
        const disposition = response.headers['content-disposition'];
        filename = disposition.split(/;(.+)/)[1].split(/=(.+)/)[1];
        if (filename.toLowerCase().startsWith("utf-8''"))
          filename = decodeURIComponent(filename.replace("utf-8''", ''));
        else filename = filename.replace(/['"]/g, '');
        return response.data;
      })
      .then((blob) => {
        var url = window.URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = url;
        a.download = filename;
        document.body.appendChild(a); // append the element to the dom
        a.click();
        a.remove(); // afterwards, remove the element
      })
      .catch((error) => {});
  };

  return (
    <>
      <Button variant="dark" size="" className="ms-3" onClick={() => downloadCSVFile()}>
        CSV出力
      </Button>{' '}
    </>
  );
};
